import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, FormGroup, Button } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import FormItem from '../../../common/forms/FormItem';
import { isRequired } from '../../../../utils/validators';
import DatePicker from '../../../common/forms/input/DatePicker';
import SupplierSelect from '../../../common/forms/select/SupplierSelect';

const ItinerarySupplierFoodSearchForm = ({ handleSubmit }) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label="Proveedor" required>
        <Field
          name="supplierId"
          component={SupplierSelect}
          isClearable={false}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>

    <FormGroup row>
      <FormItem label="Fecha Programada de Entrega" required>
        <Field
          name="dateString"
          component={DatePicker}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>

    <Row>
      <Col className="flex row-reverse">
        <Button type="submit" outline>
          <i className="fa fa-search" /> Buscar
        </Button>
      </Col>
    </Row>
  </Form>
);

ItinerarySupplierFoodSearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

const formComponent = reduxForm({
  form: 'ItinerarySupplierFoodSearchForm',
})(ItinerarySupplierFoodSearchForm);

export default formComponent;
